import { defineComponent, ref, getCurrentInstance } from "vue";
import { tabMapOptions } from "../config/option";
import store from "@/store";
export default defineComponent({
    name: "tabs-modular",
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var activeName = ref("");
        var tabClickHandle = function() {
            root.$route.query.types = Number(activeName.value) === 0 ? "" : String(activeName.value);
            store.commit("resource/updateActiveTab", Number(activeName.value));
        };
        return {
            activeName: activeName,
            tabMapOptions: tabMapOptions,
            tabClickHandle: tabClickHandle
        };
    }
});
